const data_it = `
<a href="https://www.iubenda.com/privacy-policy/55472581" class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed" title="Privacy Policy">Privacy Policy</a>
`;

const data_en = `
<a href="https://www.iubenda.com/privacy-policy/12139441" class="iubenda-white no-brand iubenda-noiframe iubenda-embed iubenda-noiframe iub-body-embed" title="Privacy Policy ">Privacy Policy</a>
`;

export {data_it, data_en};
